import { CSSProperties } from 'react';

export function brainBetAppearance(decision: string, result?: string | null, status?: string | null): CSSProperties {
  if (decision.toUpperCase() !== 'BET') return {};
  const outcome = String(result || '').toUpperCase();
  if (['WIN', 'WON'].includes(outcome)) return { color: '#111111', fontWeight: 700 };
  if (['LOSS', 'LOSE', 'LOST'].includes(outcome)) return { color: '#b66b6b', fontWeight: 400 };
  if (['VOID', 'VOIDED', 'CANCELLED', 'SCRATCHED'].includes(outcome) ||
      ['VOID', 'VOIDED', 'CANCELLED', 'SCRATCHED', 'SETTLED'].includes(String(status || '').toUpperCase())) return {};
  return { color: '#16803c', fontWeight: 400 };
}
